<template>
    <div class="BlankWrapper" :style="{'height':`${clientHeight}px`,padding:`${newsContent.newsKind==11?'.9rem 0.35rem':''}`}">
        <div class="fixedBack"><img src="../assets/img/backti.png" alt="返回" class="backToImage" @click.stop="onBack">
        </div>

        <!--        <iframe  v-if="newsContent.newsKind==4" id="show-iframe"  frameborder=0 name="showHere" scrolling=auto :src="newsContent.path" :height="clientHeight" style="width: 100%;position: absolute;height: 100%;top: 0;left: 0" ></iframe>-->
        <div v-if="newsContent.newsKind==4">
            <div class="videoWrapper" :style="`height:${clientHeight}px`" @click="()=>onVideo()">
                <div class="videoPlay">
                    <video id="video" width="100%" :poster="newsContent.imgUrl"
                           :src="newsContent.videoUrl" webkit-playsinline="true"
                           x-webkit-airplay="true" playsinline="true" x5-playsinline="true" x5-video-player-type="h5"
                           x5-video-player-fullscreen="true" x5-video-orientation="portraint" class="video"></video>
                </div>
                <div :class="['playPause',isPauseClear&&'pauseClear']"><img
                        :src="require(`../assets/img/${!isPlay?'play':'stop'}.png`)" alt="" class="playImg"
                        @click.stop="()=>onPlay()"></div>
                <div class="descWrapper">
                    <div class="videoSource">来源：{{newsContent.source}}</div>
                    <div class="videoSource">{{newsContent.newsTitle}}</div>
                </div>
            </div>
        </div>

        <div v-if="newsContent.newsKind==11">
            <div>
                <div class="newsTitle">{{newsContent.newsTitle}}</div>
                <div class="descContent">
                    <div class="source">{{newsContent.source}}</div>
                    <div class="publishTime">{{newsContent.datePublish}}</div>
                </div>
            </div>
            <div class="formatContent" v-html="newsContent.content"></div>
        </div>

    </div>
</template>

<script>
    import CONFIG from "@/utils/config";
    import COVERAPP from "@/utils/COVERAPP";
    import COVER from "@/utils/COVER";
    import QCard from "@/components/QCard";
    import {mapState, mapActions, mapMutations} from "vuex";
    import PageWrapper from "@/components/PageWrapper";

    export default {
        name: "blank",
        components: {QCard, PageWrapper},
        data() {
            return {
                iframeState: true,
                clientHeight: document.body.clientHeight,
                isPlay: false,
                isPauseClear: false,
                timeout: null
            };
        },
        computed: {
            ...mapState(["linkSrc", "newsContent"])
        },
        created() {
        },
        watch: {
            homeChat(val) {

            },
            isPlay(val) {
                let that = this;
                if (val) {

                    this.timeout = setTimeout(function () {
                            that.isPauseClear = true;
                            if (!val) {
                                clearTimeout(that.timeout);
                            }
                        }
                        , 3000);

                } else {
                    that.isPauseClear = false;
                    clearTimeout(this.timeout);
                }
            }

        },
        mounted() {
            let that = this;
            let myVideo = document.getElementById("video");
            // const {isPlay}=this
            // if(isPlay){
            //     myVideo.pause();
            //     this.isPlay=false
            // }else {
            //     myVideo.play();
            //     this.isPlay=true
            // }
            if(myVideo){
                myVideo.addEventListener("ended", function () {
                    that.isPlay = false;
                }, false);
                myVideo.addEventListener("pause", function () { //暂停开始执行的函数
                    that.isPlay = false;
                });
                myVideo.addEventListener("playing", function () { //播放中
                    that.isPlay = true;
                });
            }

        },
        destroyed() {
            clearTimeout(this.timeout);
        },
        methods: {
            onPlay() {
                let myVideo = document.getElementById("video");
                const {isPlay} = this;
                if (isPlay) {
                    myVideo.pause();
                    this.isPlay = false;
                } else {
                    myVideo.play();
                    this.isPlay = true;
                }
            },
            onVideo() {
                this.isPauseClear = false;
            },
            onBack() {
                this.$router.back(-1);

            }
        }
    };
</script>

<style lang="less" scoped>
    .detail-back-btn {
        display: none !important;
    }

    .BlankWrapper {
        overflow: auto;
        /*padding:.9rem 0.35rem;*/
    }

    .pauseClear {
        display: none !important;
    }

    .playPause {
        font-size: 0;
        overflow: hidden;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 3;

        .playImg {
            width: 1.5rem;
            height: 1.5rem;
        }
    }

    .videoWrapper {
        background: #000;
        position: relative;
        font-size: 0;
        overflow: hidden;

        .videoPlay {
            width: 100%;
            position: absolute;
            height: 100%;
            background-color: #000;

            .video {
                min-height: 100%;
                position: absolute;
                left: 0;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }
        }


        .videoSource {
            font-size: .4rem;
            color: #fff;
            padding: .3rem .4rem;
        }

        .descWrapper {
            position: absolute;
            left: 0;
            bottom: .5rem;
            width: 100%;

        }

    }

    .newsTitle {
        font-size: .6rem;
        font-weight: 700;
        padding: .2rem 0;
        color: #333333;
        line-height: .8rem;
    }

    .descContent {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .3rem 0;
        border-bottom: 0.003rem solid #a3a3a3;
        margin-bottom: .3rem;

        .source {
            font-size: .3rem;
            color: #a3a3a3;
        }

        .publishTime {
            font-size: .3rem;
            color: #a3a3a3;
        }
    }

    .fixedBack {
        position: fixed;
        right: 0.7rem;
        top: 65%;
        z-index: 1000;

        .backToImage {
            width: 1.8rem;
            height: 1.8rem;
        }
    }
</style>
